// extracted by css-extract-rspack-plugin
module.exports =  {"tableHeader":"ServiceTableHeader__tableHeader___oyqGy","left":"ServiceTableHeader__left___AwYD1","right":"ServiceTableHeader__right___kv1Ud"};